import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import BzDropdownButton, { DropdownButtonItem } from '../../../../components/buttons/BzDropdownButton';
import _ from 'lodash';
import { useIsMount } from '../../../../hooks/useIsMountHook';

interface RuntimeConfigFieldsProps {
  id: string;
  value: any;
  title: string;
  description: string;
  errorMessage?: string;
  isReadOnly: boolean;
  keyType: string;
  onChange: (value: any) => void;
  validation?: (value: any) => boolean;
  showLastValidState: boolean;
}

const RuntimeConfigFields = (props: RuntimeConfigFieldsProps) => {
  const [fieldValue, setFieldValue] = useState(_.isNil(props.value) ? '' : props.value);
  const [isDataWarningShown, setIsDataWarningShown] = useState<boolean>(false);

  const handleSelection = (item: DropdownButtonItem) => {
    if (getSelected().key !== item.key) {
      setFieldValue(item.key);
    }
  };

  const handleChange = (e: any) => {
    const target = e.target as HTMLInputElement;
    setFieldValue(target.value);
  };

  const isMount = useIsMount();
  useEffect(() => {
    if (!isMount) {
      if (props.validation === undefined || props.validation(fieldValue)) {
        if (fieldValue !== props.value) {
          props.onChange(fieldValue);
        }
        if (isDataWarningShown === true) {
          setIsDataWarningShown(false);
        }
      } else {
        setIsDataWarningShown(true);
      }
    }
  }, [fieldValue]);

  useEffect(() => {
    if (!isMount && props.showLastValidState === true) {
      setFieldValue(props.value);
    }
  }, [props.showLastValidState]);

  const dropDownElements: DropdownButtonItem[] = [
    {
      key: 'true',
      title: 'True',
    },
    {
      key: 'false',
      title: 'False',
    },
  ];

  const getSelected = () => {
    const findElement = _.isNil(fieldValue) || fieldValue === '' ? 'false' : String(fieldValue);
    return dropDownElements.find(i => i.key === findElement) as DropdownButtonItem;
  };

  return (
    <div id={props.id} className="mb-1">
      <Form.Group>
        <label className="mb-2" htmlFor={'op-' + props.id}>
          {props.title}
        </label>
        <div>
          {props.keyType === 'boolean' ? (
            <BzDropdownButton
              dropdownItems={dropDownElements}
              selectedItem={getSelected()}
              onSelectedItem={handleSelection}
              variant="secondary"
              width={'100px'}
              id={'op-' + props.id}
            />
          ) : (
            <div>
              <Form.Control
                id={'op-' + props.id}
                name="value"
                autoComplete={'off'}
                onChange={(event: any) => handleChange(event)}
                value={fieldValue}
                style={{ width: '100px' }}
                disabled={props.isReadOnly === true}
              />
              {isDataWarningShown && props.isReadOnly !== true && (
                <span className="invalid-feedback mb-1" style={{ marginBottom: '-5px' }}>
                  {props.errorMessage}
                </span>
              )}
            </div>
          )}
        </div>
        <span className="text-muted small" style={{ overflow: 'visible', textOverflow: 'clip' }}>
          {props.description}
        </span>
      </Form.Group>
    </div>
  );
};

export default RuntimeConfigFields;
